var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-header" },
          [
            _c(
              "b-button",
              {
                attrs: { variant: "primary", size: "sm", href: "/adm/migracao" }
              },
              [_vm._v("Voltar")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("b-table", {
              attrs: {
                striped: "",
                hover: "",
                items: _vm.dataComputed,
                fields: _vm.colunas
              },
              scopedSlots: _vm._u([
                {
                  key: "cell(actions)",
                  fn: function(row) {
                    return [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "primary",
                            title: "Ver"
                          },
                          on: {
                            click: function($event) {
                              return _vm.show(row.item.id)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-eye" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "success",
                            title: "Processar"
                          },
                          on: {
                            click: function($event) {
                              return _vm.editar(row.item.id)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-exchange-alt" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            size: "sm",
                            variant: "danger",
                            title: "Excluir"
                          },
                          on: {
                            click: function($event) {
                              return _vm.deletar(row.item.id)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-trash" })]
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Migração de Revendedoras" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "success",
                        size: "sm",
                        disabled: _vm.loadingSave
                      },
                      on: { click: _vm.salvaMigracao }
                    },
                    [
                      _vm.loadingSave
                        ? _c("b-spinner", {
                            attrs: {
                              small: "",
                              variant: "secondary",
                              label: "Spinning"
                            }
                          })
                        : _c("i", { staticClass: "fas fa-exchange-alt" }),
                      _vm._v(" Sim, Migrar\n      ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "secondary",
                        size: "sm",
                        disabled: _vm.loadingSave
                      },
                      on: {
                        click: function($event) {
                          _vm.openModal = false
                        }
                      }
                    },
                    [_vm._v("\n        Fechar\n      ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openModal,
            callback: function($$v) {
              _vm.openModal = $$v
            },
            expression: "openModal"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-body", [
                _c("h3", { staticClass: "text-danger" }, [_vm._v("Atenção.")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm.revendedora
                  ? _c("p", { staticClass: "text-info" }, [
                      _vm._v("\n          Você está migrando\n          "),
                      _c("span", { staticClass: "text-primary" }, [
                        _vm._v(
                          " a revendedora " + _vm._s(_vm.revendedora) + " "
                        )
                      ]),
                      _vm._v("\n          do distribuidor "),
                      _c("strong", [_vm._v(_vm._s(_vm.origem) + " ")]),
                      _vm._v(" para o distribuidor\n          "),
                      _c("strong", [_vm._v(" " + _vm._s(_vm.destino))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.revendedora
                  ? _c("p", { staticClass: "text-info" }, [
                      _vm._v(
                        "\n          Você está migrando Todas as revendedoras do distribuidor\n          "
                      ),
                      _c("strong", [_vm._v(_vm._s(_vm.origem) + " ")]),
                      _vm._v(" para o distribuidor\n          "),
                      _c("strong", [_vm._v(" " + _vm._s(_vm.destino))])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("h4", [_vm._v("Esta função irá processar a migração.")]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("h4", [_vm._v("Deseja continuar ?")])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Relatório de Migração", size: "xl", scrollable: "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "sm" },
                      on: {
                        click: function($event) {
                          _vm.modalVisible = false
                        }
                      }
                    },
                    [_vm._v("\n        Fechar\n      ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalVisible,
            callback: function($$v) {
              _vm.modalVisible = $$v
            },
            expression: "modalVisible"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-body", [
                _c("table", { staticClass: "table table-hover" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v("Nome")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Cadastro")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Endereco")])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.listaRevendedora, function(list, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(_vm._s(list.revendedora))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(list.cadastro))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(list.endereco))])
                      ])
                    }),
                    0
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db569d14", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db569d14","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_migracao/Liberacao.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-db569d14","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_migracao/Liberacao.vue
// module chunks = 2